import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import * as React from "react";
import FormButton from "../../../../../components/FormButton/FormButton";
import FormDropdown from "../../../../../components/FormDropdown/FormDropdown";
import {IRawBankAccountDetails} from "shared/functions/membersApi/types/ISignupProcess";
import {IBankAccountsData} from "../../../../../../../shared/src/functions/membersApi/types/ISignupProcess";

interface IProps {
    onBankSelected: (bankDetails: any) => void;
    oneChooseEnterBankManually: () => void;
    bankAccountsData: IBankAccountsData
}

interface ILocalState {
    bankDetails: any;
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    container: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "10em",
        textAlign :"left",
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto"
    },
    header: {
        fontSize: 15,
        fontWeight: 600,
        color: "#2f3033",
        marginBottom: "1em",
    },
    dropdownContainer: {
        marginBottom: "1em",
        width: "100%"
    },
    link: {
        fontSize: 13,
        fontWeight: 600,
        color: "#2f3033",
        textDecoration: "underline",
        marginBottom: "1em",
        cursor: "pointer",
        textAlign: "left",
        width: "100%"
    },
    buttonContainer: {
        width: "100%"
    },
    leftAlign: {
        marginRight: "auto",
    },
    rightAlign: {
        marginLeft: "auto",
        marginRight: "1em"
    }
});

@(withStyles(styles) as any)
export default class FormBankSelectionFromList extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {

    public state: ILocalState = {
        bankDetails: undefined
    }

    public render() {
        const { classes, oneChooseEnterBankManually } = this.props;
        return (
            <div className={classes!.container}>
                {this.renderAccountsList()}
                <div className={classes!.link} onClick={oneChooseEnterBankManually}>Choose different bank account</div>
                <div className={classes!.buttonContainer}><FormButton btnText={"Continue"} classes={this.state.bankDetails? "blue" : "disabled"} click={this.confirmSelectedBank}/></div>
            </div>);
    }

    private updateSelectedBank = (selectedBank: any) => {
        const newState = this.state;
        newState.bankDetails = selectedBank;
        this.setState(newState);
    };

    private confirmSelectedBank = () => {
        this.props.onBankSelected(this.state.bankDetails);
    };

    private getBankOptions = () => {
        const {bankAccountsData, classes} = this.props;
        const parsedAccounts: any =[];
        bankAccountsData.checkingAccountsData.forEach((account: IRawBankAccountDetails) => {
            parsedAccounts.push(
                    {label: <><div className={classes!.leftAlign}>{account.name}</div> <div className={classes!.rightAlign}> ******** {account.mask}</div></>,
                    value: account})
        });
        return parsedAccounts;
    };

    private renderAccountsList = () => {
        const { classes, bankAccountsData } = this.props;
        if(bankAccountsData) {
            return (
                <>
                    <div className={classes!.header}>Select a bank account for funding and monthly payments at {bankAccountsData.bankName} </div>
                    <div className={classes!.dropdownContainer}>
                        <FormDropdown placeholder={this.getBankOptions()[0].label} options={this.getBankOptions()}
                                      selectCB={this.updateSelectedBank} isDisabled={false}/>
                    </div>
                </>
            )
        }else {
            return (
                <div className={classes!.header}>Whoops, something went wrong</div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormBankSelection/FormBankSelectionFromList.tsx